export default "__VITE_ASSET__d748b4af__"